import React, { Fragment } from "react";
// import { InboxCommentsIconComponent } from "./InboxCommentsIconComponent.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import MailDownloadLink from "./MailDownloadLink.tsx";
import bytesToDisplayHelper from "../../../../utils/bytesToDisplayHelper.js";

const MailDataComponent = ({ mailData }) => {
  const { getTextByKey } = useContent();

  const size = bytesToDisplayHelper(mailData?.filesSize);

  const data = [
    <MailDownloadLink mailData={mailData} />,
    `${mailData.viewsQuantity} ${getTextByKey("inbox-views")}`,
    `${mailData?.filesQuantity || 0} ${getTextByKey("files")}`,
    size.size + " " + (size.type + ""),
  ];

  if (mailData?.mailStatus === "uploading") return <div />;

  return (
    <div className="jform-info-component">
      {data.map((item, index) => (
        <Fragment key={index}>
          <div key={index} className="mail-views">
            {item}
          </div>
          {index === 0 || index === 2 ? " | " : ""}
        </Fragment>
      ))}
    </div>
  ) 
  // : (
  //   <div className="tech-info-conponent">
  //     <MailDownloadLink mailData={mailData} />
  //     <div className="mail-views">
  //       {`${mailData.viewsQuantity} ${getTextByKey("inbox-views")}`}
  //     </div>
  //     {/* <InboxCommentsIconComponent data={mailData} /> */}
  //   </div>
  // );
};

export default MailDataComponent;
